import React, { useState, useEffect, useCallback } from 'react';
import { Card, Table, Button, Modal, Form, Input, Select, Space, Tag, message, Popconfirm, Row, Col } from 'antd';
import { PlusOutlined, ReloadOutlined, DeleteOutlined, KeyOutlined } from '@ant-design/icons';
import { apiFetch, onDataChanged } from '../utils/api.js';

const ROLE_OPTIONS = [
  { value: 'admin', label: '管理员（全部权限）' },
  { value: 'warehouse', label: '仓库（供应链：库存/采购）' },
  { value: 'other', label: '其他（仅首页）' },
];

export default function Users() {
  const [list, setList] = useState([]);
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(null); // {id, username}
  const [form] = Form.useForm();
  const [editForm] = Form.useForm();

  const loadData = useCallback(() => {
    apiFetch('/api/users').then(r => r.json()).then(d => setList(d.data || [])).catch(() => {});
  }, []);
  useEffect(() => { loadData(); }, [loadData]);
  useEffect(() => onDataChanged(() => { loadData(); }), [loadData]);

  const submitAdd = async () => {
    const v = await form.validateFields();
    const res = await apiFetch('/api/users', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(v) }).then(r => r.json());
    if (res.success) { message.success('用户已创建'); setAddModal(false); form.resetFields(); loadData(); }
    else message.error(res.error || '创建失败');
  };
  const submitEdit = async () => {
    const v = await editForm.validateFields();
    const body = {};
    if (v.password) body.password = v.password;
    if (v.role) body.role = v.role;
    const res = await apiFetch('/api/users/' + editModal.id, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }).then(r => r.json());
    if (res.success) { message.success('已更新'); setEditModal(null); editForm.resetFields(); loadData(); }
    else message.error(res.error || '更新失败');
  };
  const del = async (u) => {
    const res = await apiFetch('/api/users/' + u.id, { method: 'DELETE' }).then(r => r.json());
    if (res.success) { message.success('已删除'); loadData(); } else message.error(res.error || '删除失败');
  };

  const roleColor = { admin: 'red', warehouse: 'purple', other: 'default' };

  const columns = [
    { title: '编号', dataIndex: 'id', width: 60 },
    { title: '用户名', dataIndex: 'username', width: 120, render: v => <b>{v}</b> },
    { title: '姓名', dataIndex: 'name', width: 130 },
    { title: '角色', dataIndex: 'role', width: 140, render: v => <Tag color={roleColor[v] || 'default'}>{ROLE_OPTIONS.find(o => o.value === v)?.label || v}</Tag> },
    { title: '创建时间', dataIndex: 'created_at', width: 110 },
    {
      title: '操作', width: 170, align: 'center',
      render: (_, u) => (
        <Space size={4}>
          <Button size="small" icon={<KeyOutlined />} onClick={() => { editForm.resetFields(); editForm.setFieldsValue({ role: u.role }); setEditModal(u); }}>改角色/密码</Button>
          <Popconfirm title={`删除用户 ${u.username}？`} onConfirm={() => del(u)}>
            <Button size="small" danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div className="page-container">
      <Card
        title="用户与权限管理（管理员：全部权限 / 仓库：供应链/ 其他：仅首页）"
        extra={<Space wrap><Button icon={<PlusOutlined />} type="primary" onClick={() => { form.resetFields(); setAddModal(true); }}>新建用户</Button><Button icon={<ReloadOutlined />} onClick={loadData}>刷新</Button></Space>}
      >
        <Table rowKey="id" columns={columns} dataSource={list} size="small" pagination={false} scroll={{ x: 700 }} />
      </Card>

      <Modal title="新建用户" open={addModal} onOk={submitAdd} onCancel={() => setAddModal(false)}>
        <Form form={form} layout="vertical">
          <Row gutter={12}>
            <Col span={12}><Form.Item name="username" label="用户名" rules={[{ required: true }]}><Input /></Form.Item></Col>
            <Col span={12}><Form.Item name="name" label="姓名"><Input /></Form.Item></Col>
            <Col span={12}><Form.Item name="password" label="初始密码" rules={[{ required: true }]}><Input /></Form.Item></Col>
            <Col span={12}><Form.Item name="role" label="角色" rules={[{ required: true }]} initialValue="other"><Select options={ROLE_OPTIONS} /></Form.Item></Col>
          </Row>
        </Form>
      </Modal>

      <Modal title={`编辑用户：${editModal ? editModal.username : ''}`} open={!!editModal} onOk={submitEdit} onCancel={() => setEditModal(null)}>
        <Form form={editForm} layout="vertical">
          <Form.Item name="role" label="角色" rules={[{ required: true }]}><Select options={ROLE_OPTIONS} /></Form.Item>
          <Form.Item name="password" label="新密码（留空不修改）"><Input placeholder="留空则不修改密码" /></Form.Item>
        </Form>
      </Modal>
    </div>
  );
}
